// extracted by mini-css-extract-plugin
export default {"workCtn":"WorkMenu_workCtn__UiDXa","titleCtn":"WorkMenu_titleCtn__Vre5q","workTitle":"WorkMenu_workTitle__UyO4i","workItemCtn":"WorkMenu_workItemCtn__+fNdc"};